var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_metro-phone",
    "data-name": "Icon metro-phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.821,
    height: 38.82,
    viewBox: "0 0 38.821 38.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-phone-2",
    "data-name": "Icon metro-phone",
    d: "M31.039,27.148c-2.588,2.588-2.588,5.176-5.176,5.176s-5.176-2.588-7.764-5.176-5.176-5.176-5.176-7.764S15.511,16.8,18.1,14.208,12.923,3.856,10.335,3.856,2.571,11.62,2.571,11.62c0,5.176,5.318,15.67,10.352,20.7s15.528,10.352,20.7,10.352c0,0,7.764-5.176,7.764-7.764S33.627,24.56,31.039,27.148Z",
    transform: "translate(-2.571 -3.856)",
    fill: "#f7f2ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact3);
export default __webpack_public_path__ + "static/media/contact3.4a47cecc.svg";
export { ForwardRef as ReactComponent };